import styled from 'styled-components';

export const Container = styled.div`
  z-index: 1;
  position: absolute;
  right: 0;
  top: 0;
  padding: 30px;
  overflow: hidden;
`;
